<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.prestation',1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form>
                    <b-container>

                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="categories-group"
                                        :label="$t('message.categoriePrestation')"
                                        label-for="categories"
                                >
                                    <select id="categories" v-model="$v.form.prestation.categorie_id.$model"
                                            @change="clearErrorField('categorie_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mCategories" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <span v-if="errorshasField('categorie_id')" style="color:red">
                                    {{getErrorsField('categorie_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12" v-if="form.prestation.categorie_id =='-1' ">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nouvelle-categorie-group"
                                        :label="$t('message.nomDeLaCategorie')"
                                        label-for="nouvelle-categorie">
                                    <b-form-input
                                            id="nouvelle-categorie"
                                            v-model="$v.form.prestation.new_categorie.$model"
                                            :state="$v.form.prestation.new_categorie.$dirty ? !(errorshasField('new_categorie') || $v.form.prestation.new_categorie.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('new_categorie')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('new_categorie')">
                                        {{ getErrorsField('new_categorie') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.prestation.new_categorie.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="start-date-group"
                                        :label="$t('message.nomPrestation')"
                                        label-for="start-date">
                                    <b-form-input
                                            id="start-date"
                                            v-model="$v.form.prestation.nom.$model"
                                            :state="$v.form.prestation.nom.$dirty ? !(errorshasField('nom') || $v.form.prestation.nom.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.prestation.nom.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="prix-group"
                                        :label="$t('message.price')"
                                        label-for="prix">
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.prix.$model"
                                            :state="$v.form.prix.$dirty ? !(errorshasField('prix') || $v.form.prix.$error) : null"
                                            placeholder=""
                                            type="number"
                                            step="0.01"
                                            @focus="clearErrorField('prix')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('prix')">
                                        {{ getErrorsField('prix') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.prix.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="reduction-group"
                                        :label="$t('message.reduction')"
                                        label-for="prix">
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.reduction.$model"
                                            :state="$v.form.reduction.$dirty ? !(errorshasField('reduction') || $v.form.reduction.$error) : null"
                                            placeholder=""
                                            type="number"
                                            step="0.01"
                                            @focus="clearErrorField('reduction')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('reduction')">
                                        {{ getErrorsField('reduction') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.reduction.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>

                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>
                        </b-row>
                    </b-container>


                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import SlimSelect from "slim-select";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: "Edit",

        computed: {
            ...mapGetters(["errors","etablissementPrestation", 'hasAdminRole',
                'hasGestionnaireRole', 'hasMedecinControleRole',"categoriePrestations",'isComptable']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable;
            },

            form:function () {
                return this.etablissementPrestation;
            },

            mCategories:function () {
                let cArray = [];
              cArray.push({nom:this.$i18n.t('message.addAutreCategorie'),id:"-1"});
              _.forEach(this.categoriePrestations, function (categorie) {
                    cArray.push({nom:categorie.nom,id:categorie.id});

                })
                cArray.push({nom:this.$i18n.tc('message.aucun',2),id:"0"});
                return cArray;
            }
        },

        data() {
            return {
                categorieSelect:Object,
                prestation_id: this.$route.params.prestation_etablissement,
            }
        },

        methods:{
            getPrestation() {
                let args = {
                    prestation: this.prestation_id,
                };
                this.$store.dispatch("getEtablissementPrestation", {args});
            },

            getCategoriePrestations() {
                let args = {

                };

                this.$store.dispatch('getCategoriePrestations', { args : args });
            },

            categorieNonExistente:function () {
                return !(this.form.prestation.categorie_id == "-1" && this.form.prestation.new_categorie == '');
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        prestation:this.prestation_id,
                        prestation_id: this.form.prestation_id,
                        etablissement_id:this.form.etablissement.id,
                        nom: this.form.prestation.nom,
                        prix:this.form.prix,
                        reduction:this.form.reduction,
                        categorie_id: this.form.prestation.categorie_id == '0' || this.form.prestation.categorie_id == '-1' ? null : this.form.prestation.categorie_id,
                        new_categorie:this.form.prestation.categorie_id == '-1' ? this.form.prestation.new_categorie : null

                    };

                    let successMessage = this.$i18n.t('message.prestationUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateEtablissementPrestation', { args, errorMessages, successMessage })
                }
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
        },

        mounted() {
            this.getCategoriePrestations();

            this.getPrestation();

            var categorie = new SlimSelect({
                select: '#categories',
                placeholder: 'Select categorie',
                limit: 1
            });

            this.categorieSelect = categorie;
        },

        validations() {
            return {
                form: {
                    prestation:{
                        nom: {required},
                        new_categorie:{ categorieNonExistente:this.categorieNonExistente},
                        categorie_id:{}
                    },
                    prix:{required},
                    reduction:{},
                }
            }
        },
    }
</script>

<style scoped>

</style>